// extracted by mini-css-extract-plugin
export default {"root":"p2rR-HOYoOyKyCvUjRaN1w==","content":"BhdO3Tuo03KQernYJTd7zA=="};